import { createComponent } from '@lit/react';
import React from 'react';
import { SDSRadioGroup } from '../sds-radio-group/sds-radio-group';
import { SheriffEventName } from './types';

export const SDSRadioGroupWrapper = createComponent({
	tagName: 'sds-radio-group',
	elementClass: SDSRadioGroup,
	react: React,
	events: {
		onUpdate: 'sds-update' as SheriffEventName,
		onChange: 'change' as SheriffEventName,
	},
});
